var _path, _g, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m441.4 140.2v338.8c0 18.2-14.8 33-33 33h-304.8c-18.2 0-33-14.8-33-33v-446c0-18.2 14.8-33 33-33h197.6z",
    fill: "#518ff5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m161.2 257.1h189.6v21.1h-189.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.2 304.1h189.6v21.1h-189.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.2 351.2h189.6v21.1h-189.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.2 398.2h134.9v21.1h-134.9z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m320.3 134.9 121.1 98.1v-92.2l-68.6-39.8z",
    opacity: 0.19
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m441.4 140.2h-107.2c-18.2 0-33-14.8-33-33v-107.2z",
    fill: "#a6c5fa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.cd08b4a3397d2338b6573a0427f78496.svg";
export { ForwardRef as ReactComponent };